import React, {ReactNode} from 'react';
import {makeStyles} from "@mui/styles";

interface Props {
    readonly children?: ReactNode
}

const useStyles = makeStyles({
    root: {
        width:"100%",
        borderCollapse: "collapse",
        textAlign: "center",
        "& tr, & thead,": {
            borderBottom: "1px solid rgb(230, 230, 230)",
        },
        "& tr:hover": {
                background: "#FAFAFA",
        },
        "& th, & td": {
            padding: "15px 10px",
            fontSize: "16px",
        },
        "& th": {
            color: "#333",
        },
        "& td": {
            fontSize: "16px",
            wordBreak: "break-all",
            color: "#424242",
        }
    }
});

export function Table({children}:Props) {
    const classes = useStyles();
    return (
        <table className={classes.root}>
            {children}
        </table>
    );
}

